import React, { Component, ErrorInfo, ReactNode } from 'react';
import { ErrorLayout } from '@components-shared/ErrorLayout';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
// @ts-ignore: remove after translating into typescript
import { getAppInsights } from 'applicationInsights/TelemetryService';

interface IErrorBoundaryState {
  hasError: boolean;
  error: Error | Record<string, undefined>;
  errorInfo: ErrorInfo | Record<string, undefined>;
}
interface IErrorBoundaryProps {
  children: ReactNode;
}

class ErrorBoundary extends Component<IErrorBoundaryProps, IErrorBoundaryState> {
  constructor(props: IErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: {},
      errorInfo: {},
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    this.setState({
      hasError: true,
      error,
      errorInfo,
    });
  }

  render(): ReactNode {
    const { hasError, error, errorInfo } = this.state;

    if (hasError) {
      const message = error ? error.message : 'Error';
      const appInsightsError = new Error(message);

      if (error) {
        appInsightsError.stack = error.stack;
      }

      try {
        const appInsights = getAppInsights();

        if (appInsights) {
          appInsights.trackException({
            error: appInsightsError,
            severityLevel: SeverityLevel.Critical,
          });
        }
      } catch (e) {
        console.error('appInsights error');
      }

      return <ErrorLayout stack={errorInfo.componentStack} message={message} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
